import { useHistory } from "react-router-dom";


export const getUser = () => JSON.parse(window.sessionStorage.getItem("current"));

export const setUser = (id) => window.sessionStorage.setItem("current", JSON.stringify(id));

export const redirectTo = (url) => {
    let history = useHistory;

    history.push(`${url}`)
}


export const orderProductos = (array, order) => {
    if (array.length < 1) return [];
    let arraySorted;
    switch (order) {
        case "a-z":
            arraySorted = array.map((categoria) => {
                return { categoria: categoria.categoria, registros: categoria.registros.sort((a, b) => a.Titulo.localeCompare(b.Titulo)) }
            })
            break;
        case "z-a":
            arraySorted = array.map((categoria) => { return { categoria: categoria.categoria, registros: categoria.registros.sort((a, b) => b.Titulo.localeCompare(a.Titulo)) } })
            break;
        case "menor-mayor":
            arraySorted = array.map((categoria) => { return { categoria: categoria.categoria, registros: categoria.registros.sort((a, b) => a.PrecioOferta - b.PrecioOferta) } })
            break;
        case "mayor-menor":
            arraySorted = array.map((categoria) => { return { categoria: categoria.categoria, registros: categoria.registros.sort((a, b) => b.PrecioOferta - a.PrecioOferta) } })
            break;
        default:
            break;
    }
    return arraySorted;
}

export const orderRepuestos = (array, order) => {
    if (array.length < 1) return [];
    let arraySorted;
    switch (order) {
        case "a-z":
            arraySorted = array.sort((a, b) => a.Titulo.localeCompare(b.Titulo));
            break;
        case "z-a":
            arraySorted = array.sort((a, b) => b.Titulo.localeCompare(a.Titulo));
            break;
        case "menor-mayor":
            arraySorted = array.sort((a, b) => a.PrecioOferta - b.PrecioOferta);
            break;
        case "mayor-menor":
            arraySorted = array.sort((a, b) => b.PrecioOferta - a.PrecioOferta);
            break;
        default:
            break;
    }
    return arraySorted;
}

export const orderVehiculos = (array, order) => {
    if (array.length < 1) return [];
    let arraySorted;
    switch (order) {
        case "a-z":
            arraySorted = array.map((categoria) => {
                return { categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => a.Nombre.localeCompare(b.Nombre)) }
            })
            break;
        case "z-a":
            arraySorted = array.map((categoria) => { return { categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => b.Nombre.localeCompare(a.Nombre)) } })
            break;
        case "menor-mayor":
            arraySorted = array.map((categoria) => { return { categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => a.precioOferta - b.precioOferta) } })
            break;
        case "mayor-menor":
            arraySorted = array.map((categoria) => { return { categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => b.precioOferta - a.precioOferta) } })
            break;
        default:
            break;
    }
    return arraySorted;
}

export const paginador = (array,catidad) =>{
    let cantidadPorPagina = catidad;
    let totalArticulos
}

export const orderVehiculosMercado = (array, order) => {
    if (array.length < 1) return [];
    let arraySorted;
    switch (order) {
        case "a-z":
            arraySorted = array.map((categoria) => {
                return { categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => a.Nombre.localeCompare(b.Nombre)) }
            })
            break;
        case "z-a":
            arraySorted = array.map((categoria) => { return { idCategoria: categoria.idCategoria, categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => b.Nombre.localeCompare(a.Nombre)) } })
            break;
        case "menor-mayor":
            arraySorted = array.map((categoria) => { return { idCategoria: categoria.idCategoria,categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => a.Precio - b.Precio) } })
            break;
        case "mayor-menor":
            arraySorted = array.map((categoria) => { return {idCategoria: categoria.idCategoria, categoria: categoria.categoria, vehiculos: categoria.vehiculos.sort((a, b) => b.Precio - a.Precio) } })
            break;
        default:
            break;
    }
    return arraySorted;
}

export const orderModuloRepuestos = (array, order) => {
    if (array.length < 1) return [];
    let arraySorted;
    switch (order) {
        case "a-z":
            arraySorted = array.sort((a, b) => a.Titulo.localeCompare(b.Titulo));
            break;
        case "z-a":
            arraySorted = array.sort((a, b) => b.Titulo.localeCompare(a.Titulo));
            break;
        case "menor-mayor":
            arraySorted = array.sort((a, b) => a.PrecioNormal - b.PrecioNormal);
            break;
        case "mayor-menor":
            arraySorted = array.sort((a, b) => b.PrecioNormal - a.PrecioNormal);
            break;
        default:
            break;
    }
    return arraySorted;
}

export const moneda = (moneda) => moneda === 'CLP' ? '$' : 'USD '